/* eslint-disable react-dom/no-unsafe-target-blank */
import { Trans, useLingui } from '@lingui/react/macro'

import style from '../../_components/H2/index.module.scss'
import { H2 } from '../../_components/H2'

import LazyImage from '@/components/LazyImage'


import { cls } from 'tagged-classnames-free';
import Link from '@/components/Link';
export const Banner: React.FC = () => {
  const { t } = useLingui()

  return (
    <div className='relative z-[1] mx-auto max-w-[1206px] px-4 pt-[100px] text-center md:pt-[144px]'>
      <h1
        className={cls`mx-auto ${style.heightLightText} max-w-[1000px] text-4xl font-bold md:text-[100px] md:font-black md:leading-snug`}
      >
        <Trans>About Us</Trans>
      </h1>
      <LazyImage
        width={1174}
        height={124}
        src={'/images/about-us/about-us.png'}
        alt={t`About Us`}
        className='mt-2'
      />
      <div className='bg-f-bg-container relative mt-6 max-w-[1080px] rounded-xl px-6 py-3 text-center md:mt-16 md:rounded-3xl md:px-[140px] md:py-20'>
        <H2>
          <Trans>What Is Tad.AI?</Trans>
        </H2>
        <p className='text-f-other-10 pt-3 text-sm md:pt-6 md:text-base'>
          <Trans>
            Tad.ai is an{' '}
            <Link
              href={'/ai-music-generator'}
              className='text-f-primary hover:underline'
            >
              AI music generator
            </Link>{' '}
            that enables users to generate custom music tracks based on
            preferences like mood, genre, etc. Developed by{' '}
            <Link
              href={'https://hix.ai'}
              className='text-f-primary hover:underline'
              target='_blank'
              rel='nofollow noreferrer'
            >
              HIX.AI
            </Link>
            , a Singapore-based all-in-one AI solution provider, the purpose of
            this tool is to provide anyone with the ability to instantly create
            original music compositions for a wide range of personal and
            professional applications.
          </Trans>
        </p>
        <p className='text-f-other-10 pt-3 text-sm md:pt-6 md:text-base'>
          <Trans>In partnership with </Trans>
          <Link
            href={'https://www.kunlun.com/en/'}
            className='text-f-primary hover:underline'
            target='_blank'
          >
            <Trans>Kunlun Tech</Trans>
          </Link>
          <Trans>
            , Tad AI leverages their officially licensed large model known as
            Skymusic 2.0. This advanced model allows Tad AI to process lyrics
            inputs of over 500 words and generate songs that can last up to 6
            minutes in high-quality stereo sound. With these capabilities, Tad
            AI stands out as a powerful tool for music creators, offering
            enhanced quality and versatility in music production.
          </Trans>
        </p>
        <LazyImage
          width={103}
          height={64}
          src={'/images/about-us/icon.png'}
          alt={t`What Is Tad.AI?`}
          className='absolute -bottom-2 end-[140px] hidden md:block'
        />
      </div>
    </div>
  )
}
